module.exports = __webpack_public_path__ + "static/media/icon-download.b9507c72.svg";